import { useCallback, CSSProperties } from 'react';
import { useDispatch } from 'react-redux';
import { cacheCliRequest, sqlRequest } from 'actions/adminActions';
import { Permission } from 'shared/permissions';
import { useSession } from 'hooks';
import { CacheId } from 'shared/models';

export type Props = {
    label?: string;
    cacheId?: CacheId;
    command?: string;
    sql?: string;
    params?: any[];
};

const style: CSSProperties = {
    cursor: 'pointer',
    textDecoration: 'underline',
    padding: '.4em .3em',
    color: '#0000cc',
};

function removeExtraSpacingFromSql(input: string): string {
    const [ , initialSpaces = '', sql ] = /[\n\r]*(\s*)(.*)$/s.exec(input) || [];
    const nSpaces = initialSpaces.length;
    const lines = sql.split(/\r?\n/);
    return lines.map(line =>
        line.startsWith(initialSpaces)
            ? line.substr(nSpaces)
            : /^\s*$/.test(line)
                ? ''
                : line
    ).join('\n');
}

export const DebugLink = ({ label, cacheId, command, sql, params }: Props) => {
    const { hasPermission } = useSession();

    const dispatch = useDispatch();

    const handleClick = useCallback(() => {
        if (cacheId && command) {
            dispatch(cacheCliRequest(command, { cacheId }));
        }
        else if (sql) {
            dispatch(sqlRequest({ sql: removeExtraSpacingFromSql(sql), params }));
        }
    }, [ dispatch, cacheId, command, sql, params ]);

    // Only administrators are allowed to see the /admin/cache page
    if (!hasPermission(null, Permission.DebugRead)) {
        return null;
    }
    
    return (
        <div className="_dl" onClick={ handleClick } style={ style }>
            { label || 'debug' }
        </div>
    );
};
